import { Injectable } from '@angular/core';
import { UserService } from '@app/core/services/user.service';
import * as InitGridActions from '@app/pcs/actions/init-grid';
import { InitGridActionTypes } from '@app/pcs/actions/init-grid';
import { GridType } from '@app/pcs/models';
import { GridService } from '@app/pcs/services/grid.service';
import { getGridColumns, updateGridColumnsByDefaultColumns } from '@app/pcs/util';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { hasValue, mapPayload } from '@util';
import { initGrid } from 'ngrx-data-grid';
import { switchMap, withLatestFrom } from 'rxjs/operators';

@Injectable()
export class InitGridEffects {

  initDisplayGridWithData$ = createEffect(() => this.actions$.pipe(
    ofType<InitGridActions.InitDisplayGridWithData>(InitGridActionTypes.InitDisplayGridWithData),
    mapPayload(),
    withLatestFrom(this.gridService.getGridColumns(GridType.Display), this.gridService.getGridPagination(GridType.Display)),
    switchMap(([{data, defaultColumns, actions = [], configuration}, gridColumns, gridPagination]) => [
      initGrid({
        columns: this.columns(defaultColumns, gridColumns, configuration),
        data: data,
        name: GridType.Display,
        paginationPageSize: this.pagination(gridPagination)
      }),
      ...actions]
    )));

  initSearchGridWithData$ = createEffect(() => this.actions$.pipe(
    ofType<InitGridActions.InitSearchGridWithData>(InitGridActionTypes.InitSearchGridWithData),
    mapPayload(),
    withLatestFrom(this.gridService.getGridColumns(GridType.Search), this.gridService.getGridPagination(GridType.Search)),
    switchMap(([{data, defaultColumns, actions = [], configuration}, gridColumns, gridPagination]) => [
      initGrid({
        columns: this.columns(defaultColumns, gridColumns, configuration),
        data: data,
        name: GridType.Search,
        paginationPageSize: this.pagination(gridPagination)
      }),
      ...actions
    ]
    )
  ));

  private columns = (defaultColumns, gridColumns, configuration) =>
    hasValue(configuration)
      ? getGridColumns(defaultColumns, configuration)
      : updateGridColumnsByDefaultColumns(defaultColumns, gridColumns);

  private pagination = (gridPagination) =>
    hasValue(gridPagination.paginationPageSize)
      ? gridPagination.paginationPageSize
      : this.userService.getDefaultPageSize();

  constructor(
    private actions$: Actions,
    private userService: UserService,
    private gridService: GridService,
    private store: Store<any>
  ) {
  }

}
